/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { BarChart, Bar, Cell, ResponsiveContainer } from "recharts";
import TrendingUpIcon from "mdi-react/TrendingUpIcon";
import TrendingDownIcon from "mdi-react/TrendingDownIcon";
import * as dashboardgraphs from "../../../../shared/service/dashboardgraphs";

class DashboardGraph extends PureComponent {
  state = {
    activeIndex: 0,
    period: "day",
    data: [],
    loading: true,
    error: false,
  };

  handleClick = (index) => {};

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    this.setState({ data: [], loading: true }, () =>
      dashboardgraphs
        .get(this.props.type, this.state.period)
        .then((data) => this.setState({ data: data, loading: false }))
        .catch((err) =>
          this.setState({ data: [], loading: false, error: true })
        )
    );
  };

  change = (event) => {
    this.setState({ period: event.target.value }, () => this.getData());
  };

  render() {
    return (
      <Col md={12} xl={3} lg={6} xs={12}>
        <Card>
          <CardBody
            className="dashboard__card-widget"
            style={{ padding: "15px" }}
          >
            <div className="card__title">
              <h5 className="bold-text">{this.props.title}</h5>
              <select
                onChange={this.change}
                dir="ltr"
                style={{
                  position: "absolute",
                  right: "0px",
                  top: "0px",
                  border: "none",
                }}
              >
                <option value="day">Day</option>
                <option value="week">Week</option>
                <option value="month">Month</option>
              </select>
            </div>
            {this.state.loading === true ? "Loading ..." : ""}
            {this.state.data.length > 0 ? (
              <div className="dashboard__total">
                {this.state.data[0].value > this.state.data[9].value ? (
                  <TrendingUpIcon className="dashboard__trend-icon" />
                ) : (
                  <TrendingDownIcon className="dashboard__trend-icon" />
                )}

                <p className="dashboard__total-stat">
                  {this.state.data[0].value}
                </p>
                <ResponsiveContainer
                  height={50}
                  className="dashboard__chart-container"
                >
                  <BarChart data={this.state.data}>
                    <Bar dataKey="value" onClick={this.handleClick}>
                      {this.state.data.map((entry, index) => (
                        <Cell
                          cursor="pointer"
                          fill={
                            index === 0
                              ? this.props.activeColor
                              : this.props.barColor
                          }
                          key={`cell-${index}`}
                        />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            ) : this.state.error === true ? (
              "Error while loading data"
            ) : this.state.loading === false ? (
              "No record found."
            ) : (
              ""
            )}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default DashboardGraph;
